<template>
    <layout-default>
        <div style="padding: 150px 0;">
            <div class="container">
                <div class="row">
                    <div class="col">
                        <h3 class="mb-4">MODALS</h3>
                        <div class="mb-4">
                            <a href=".close-session-alert-modal" class="btn-pdv-primary " data-toggle="modal">MODAL: SE CERRARÁ LA SESIÓN</a>
                        </div>

                        <div class="mb-4">
                            <a href=".session-closed-alert-modal" class="btn-pdv-primary" data-toggle="modal">MODAL: SESIÓN CERREDA</a>
                        </div>

                        <div class="mb-4">
                            <a href=".backpack-empty-modal" class="btn-pdv-primary" data-toggle="modal">MODAL MOCHILA VACÍA</a>
                        </div>

                        <div class="mb-4">
                            <a href=".delete-course-modal" class="btn-pdv-primary" data-toggle="modal">delete-course-modal</a>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <delete-course-modal></delete-course-modal>

    </layout-default>
</template>

<script>
    import LayoutDefault from "@/layouts/Default";
    import deleteCourseModal from "@/components/modals/deleteCourseModal"


    export default {
        components:{
            LayoutDefault,
            deleteCourseModal
        }
    }
</script>

<style scoped>

</style>